import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=d19f980a&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19f980a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d19f980a')) {
      api.createRecord('d19f980a', component.options)
    } else {
      api.reload('d19f980a', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=d19f980a&scoped=true&", function () {
      api.rerender('d19f980a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PSsnpjNJuLRb/JS/comp/Voucher-Unit.vue"
export default component.exports